import axios from './axios';
import { getTodayDateInputValue } from '../utils/date';

export async function descargarClientesPdf(ids) {
  const response = await axios.post('/usuarios/clientes/pdf', { ids }, { responseType: 'blob' });
  const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = `clientes_${getTodayDateInputValue()}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
